import { useState } from 'react'
import { H3 } from '../../components/Text'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const UserInformation = (props) => {
  const { user } = useAuth()
  const [dropDown, setDropDown] = useState(false)

  if (user) {
    return (
      <div className="">
        <button
          className="flex items-center gap-2 transition-all duration-200 bg-[#0e365c] hover:bg-[#265078] py-1.5 px-3 rounded-md"
          onClick={() => setDropDown(!dropDown)}
        >
          {user.user?.photoUrl === null ? (
            <div className="text-[1.8rem] flex justify-center items-center rounded-full">
              <i className="fa-solid fa-user-circle text-white"></i>
            </div>
          ) : (
            <img src={user.user?.photoUrl} alt="" className="w-[25px]" />
          )}
          <H3 className="text-[#F19E4D] font-semibold leading-none text-[0.9rem] text-start">
            {user.user?.name}
            <br />
            <span className="text-white">
              {user.user?.fatherLastName} {user.user?.motherLastName}
            </span>
          </H3>
          {/* <FontAwesomeIcon
            icon={`fas fa-angle-${dropDown ? 'up' : 'down'}`}
            className="text-white"
          /> */}
        </button>
        {dropDown && (
          <>
            <div
              onClick={() => setDropDown(!dropDown)}
              className="absolute w-screen h-screen top-0 left-0"
            ></div>
            <div className="absolute z-10 w-fit right-2 mt-2">
              <Dropdown setDropDown={setDropDown} dropDown={dropDown} />
            </div>
          </>
        )}
      </div>
    )
  } else {
    return null
  }
}

const Dropdown = ({ setDropDown, dropDown }) => {
  const navigate = useNavigate()
  const { setUser, user } = useAuth()
  return (
    <div className="bg-white shadow-lg flex flex-col rounded-md p-2 gap-2">
      {/* {JSON.stringify(user)} */}
      <div
        className="flex items-center gap-1"
      >
        {user.user?.photoUrl === null ? (
          <i className="fa-solid fa-user-circle text-[#265078] text-md"></i>
        ) : (
          <img src={user.user?.photoUrl} alt="" className="w-[25px]" />
        )}
        <H3 className="text-gray-700 font-semibold leading-none text-sm sm:text-sm xl:text-sm text-start">
          {user.user?.name} {user.user?.fatherLastName} {user.user?.motherLastName}
        </H3>
      </div>
      <div
        className="flex items-center gap-1"
      >
        <i className="fa-solid fa-at text-[#265078] text-md"></i>
        <H3 className="text-gray-700 font-semibold leading-none text-xs sm:text-xs xl:text-xs text-start">
          {user.user?.email}
        </H3>
      </div>
      <button
        className="text-sm mt-3 p-2 bg-gray-200 font-medium flex flex-row items-center hover:bg-red-500 hover:text-white rounded-md justify-center"
        onClick={() => {
          localStorage.removeItem('id')
          localStorage.removeItem('token_seguridad')
          setDropDown(!dropDown)
          setUser()
          navigate('/')
        }}
      >
        <FontAwesomeIcon
          icon="fa-solid fa-arrow-right-from-bracket"
          className="text-sm font-bold mr-2"
        />
        Cerrar Sesión
      </button>
    </div>
  )
}

export default UserInformation
